import React, { Component } from 'react';

class CustomCheckbox extends Component {
  constructor(props){
    super(props);
    this.state = {
      is_checked: props.isChecked,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(){
    this.setState({is_checked: !this.state.is_checked});
    this.props.handleOnChange && this.props.handleOnChange(!this.state.is_checked);
  }
  render() {
    const { isChecked, number, label, inline, colorbox, handleOnChange, ...rest } = this.props;
    const classes = inline !== undefined ? "checkbox checkbox-inline":"checkbox";
    const colorboxClass = colorbox ? 'color-box' : '';
    return (
      <div className={classes} {...rest}>
        <input id={number} type="checkbox" onChange={this.handleClick} checked={this.state.is_checked} {...rest}/>
        <label htmlFor={number}>
          {label}
        </label>
        <span style={{backgroundColor: colorbox}} className={colorboxClass}></span>
      </div>
    );
  }
}

export default CustomCheckbox;



// WEBPACK FOOTER //
// ./src/elements/CustomCheckbox/CustomCheckbox.jsx